<template>
    <section class="hero is-light is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-5-tablet is-5-desktop is-4-widescreen">
                        <h1 class="title has-text-centered">
                            <img src="@/assets/images/logo.svg" width="120">
                        </h1>
                        <p v-if="IsProdEnvMode!=true" style="text-align: center; background-color: red; color: white; font-weight: bold;" class="box">Development Test Environment Mode is Active</p>
                        <form class="box has-shadow" @submit.prevent="tryLogin">
                             <!-- <div class="field">
                                <label class="label">Active Directory OU</label>
                                <div class="control has-icons-left">
                                  <select class="select is-medium"  v-model ="selectedOU">
                                    <option v-for="(ouItem,index) in oulist" :key="index" :value="ouItem" id="userRole">
                                        {{ouItem}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            -->

                              <div class="field">
                                 <label class="label">Email</label>
                                 <div class="field has-addons">
                                    <div style="width: 100%" class="control has-icons-left">
                                       <input class="input is-medium" type="text" v-model="username">
                                       <span class="icon is-small is-left">
                                          <font-awesome-icon icon="envelope"/>
                                       </span>
                                    </div>
    <!--                                    <div class="control">-->
    <!--                                        <a class="button is-small is-static">-->
    <!--                                            @corendon-airlines.com-->
    <!--                                        </a>-->
    <!--                                    </div>-->
                                 </div>
                              </div>

                              <div class="field">
                                 <label class="label">Password</label>
                                 <div class="control has-icons-left">
                                    <input class="input is-medium" type="password" v-model="password">
                                    <span class="icon is-small is-left">
                                        <font-awesome-icon icon="lock"/>
                                    </span>
                                 </div>
                              </div>
                            <div class="field">

                            </div>
                            <button class="button is-medium is-success is-fullwidth" :disabled="isLoading">
                                <span class="icon is-small">
                                        <font-awesome-icon :icon="isLoading ? 'spinner' : 'sign-in-alt'"
                                                           :spin="isLoading"/>
                                </span>
                                <span>
                                    Login
                                </span>

                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    import {createNamespacedHelpers} from 'vuex';
    import {loadingMixin} from "../../utils/mixins";

    const {mapActions,mapState} = createNamespacedHelpers('auth');

    export default {
       name: "Login",
       mixins: [loadingMixin],
       async created()
       {
           try
           {
               await this.getIsProdEnvironment();
               this.IsProdEnvMode = this.IsProdEnvironment ;

               // await this.EnumarateADOUList();   20220601
               // this.selectedOU = this.oulist[0];
           }
           catch(e)
           {
               //this.$notify({title: "Error", text:"Couldn't access Eff server. Please check your internet connection."+e.message , type: "error"});
           }
       },

      methods:
      {


            ...mapActions(["login","getIsProdEnvironment"]),

            async tryLogin() {
                this.showLoading();
                try {
                    await this.login({email: this.email, password: this.password, selectedOU:this.selectedOU});
                    //this.$notify({title: "Success", text: "You have just logged in successfully.", type: "success",});

                } catch (e) {

                    //this.$notify({title: "Error", text:"Error on tryLogin function e: " + e.response.data +".", type: "error"});

                } finally {

                    this.hideLoading();

                }
            }

        },

        computed:
        {
            ...mapState(["IsProdEnvironment"]),
            email()
            {
                // return `${this.username}@corendon-airlines.com`;
                return `${this.username}`;
            }
        },

        data()
        {
            return {
                IsProdEnvMode: false,
                username: '',
                password: '',
                selectedOU: '',
            }
        }

    }
</script>

<style scoped>

</style>
